import { Button, CircularProgress } from "@mui/material";

export default function FormSubmitButton({
  isLoading,
  handleSubmit,
  buttonText,
  ButtonIcon,
  buttonColor,
  disabled = false,
  testId,
  alignLeft,
  buttonId,
  sx,
}) {
  const content = isLoading ? "Loading..." : buttonText;
  const Icon = ButtonIcon;
  const loadingStyle = isLoading ? "py-0" : "py-2";
  const buttonStyle = (buttonColor) => {
    if (buttonColor) {
      return `bg-${buttonColor}-600 hover:bg-${buttonColor}-700`;
    }
    return "";
  };
  const disabledColors = (color) => {
    if (color === "red") {
      return "rgb(185 28 28)";
    } else if (color === "orange") {
      return "rgb(194 65 12)";
    } else if (color === "sky") {
      return "rgb(3 105 161)";
    } else if (color === "green") {
      return "rgb(77 124 15)";
    } else if (color === "purple") {
      return "rgb(107 33 168)";
    } else {
      return "";
    }
  };

  const alignClasses = alignLeft ? "" : "w-fit mx-auto";

  return (
    <div className={alignClasses}>
      <Button
        id={buttonId}
        data-testid={testId}
        onClick={(e) => handleSubmit(e)}
        variant="contained"
        disabled={disabled || isLoading}
        className={`${loadingStyle} ${buttonStyle(buttonColor)}`}
        sx={[
          {
            "&:disabled": {
              background: disabledColors(buttonColor),
              color: "#FFF",
            },
          },
          sx,
        ]}
      >
        {content}&nbsp;
        {isLoading ? (
          <div className="relative mt-2 block pl-4">
            <CircularProgress
              sx={{
                color: "#FFF",
                maxWidth: "25px",
                maxHeight: "25px",
              }}
            />
          </div>
        ) : !Icon ? (
          ""
        ) : (
          Icon
        )}
      </Button>
    </div>
  );
}
